export default {
    // url:'http://127.0.0.1:8000/'
    // url: 'http://3.88.85.200:80/'
    // url: 'https://zuk.codedady.com/'  // Aws
    url: 'https://zukhrof.codedady.com/'  // Digital ocea
    // url: 'https://api.zukhrofrealestate.com/'
    // url: 'http://192.168.0.142:8000/'
}


// axios.get(
//     Base.url + 'AdminDashboard/',
//     {
//         headers: {
//             'Authorization': 'Token ' + localStorage.getItem('Token'),
//         }
//     }
// ).then(response => {
//     console.log('Response Normal :', response);

//     this.setState({
//         data: response.data.results,
//         next: response.data.next,
//         prev: response.data.previous,
//     })

// }).catch(error => {
//     console.log('Error loading quotation count: ', error);
//     NotificationManager.error('Error : ', error, 3000);
// })


// var bodyFormData = new FormData();
// bodyFormData.set('username', username);
// bodyFormData.set('password', password);

// axios.post(
//     Base.url + 'Login/',
//     bodyFormData,
//      {
//         headers: {
//             'Authorization': 'Token ' + localStorage.getItem('Token'),
//         }
//     }
// )
// .then(response =>{
//     console.log('response : ',response);
//         if(response.data.Status){
//             alert(response.data.Message)
//         }else{
//             console.log(response.data.Message);
//             alert(response.data.Message+" : "+response.data.Error)
//         }
// })
// .catch(error=>{
//     console.log(error);
// })

// axios.delete(
//     Base.url + 'Priority/?id='+data.id,
//     {
//         headers: {
//             'Authorization': 'Token ' + localStorage.getItem('Token'),
//         }
//     }
// )
// .then(response =>{
//     console.log('response : ',response);
//         if(response.data.Status){
//             alert(response.data.Message)
//             this.fetchAllData()
//             this.loading(false)
//         }else{
//             console.log(response.data.Message);
//             alert(response.data.Message+" : "+response.data.Error)
//             this.loading(false)

//         }
// })
// .catch(error=>{
//     console.log(error);
// })
